import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import { setSelectedCampaignsForCampaign, setSelectedRowsForNegativesCampaign } from "../../../../../../../../../../features/searchTermOperationSlice";
import FilterComponent from "../../../../../../../../../ReusableFIlterComponent/FilterComponent";

export default function NegativeSearchCampaignFilterItems({
  clearSelectedSearchTerm,
}: any) {
  const { negativesInTheCampaignData, selectedCampaignsForCampaign } =
    useSelector((state: any) => state.searchTermOperation);

  const dispatch = useDispatch();
  const [searchCampaigns, setSearchCampaigns] = useState("");

  const filterConfig = [
    {
      key: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaignsForCampaign,
      filterName: "campaign_name",
      data: negativesInTheCampaignData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCampaignsForCampaign(updatedSelection)),
      count:
        selectedCampaignsForCampaign && selectedCampaignsForCampaign.length,
      colorSelected:
        selectedCampaignsForCampaign !== null &&
        selectedCampaignsForCampaign.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaignsForCampaign([]));
    dispatch(setSelectedRowsForNegativesCampaign([])); //reset selected rows
    clearSelectedSearchTerm(null);
    setSearchCampaigns("");
  };

  return (
    <Box data-tracker="136">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
